<template>
	<div class="gallery-item">
		<a
			:data-src="!isVideo ? item.image : item.embedCode"
			:class="{ 'fancybox.iframe': isVideo }"
			data-fancybox="gallery"
			:data-caption="item.imageAlt"
			:title="item.imageAlt"
		>
			<font-awesome-icon v-if="!isVideo" class="icon" icon="fa fa-search" />
			<font-awesome-icon v-else class="icon" icon="fas fa-play" />
			<picture>
				<source v-if="item.imagesWebp" :srcset="item.imagesWebp[1]" type="image/webp" />
				<source :srcset="item.images[1]" />
				<img :src="item.images[1]" :alt="item.imageAlt" loading="lazy" />
			</picture>
		</a>
	</div>
</template>

<script setup>
const props = defineProps({
	item: {
		type: Object,
		default: () => ({
			embedCode: '',
			image: '',
			images: [],
			imageAlt: '',
			imageWebp: '',
			type: 'image',
		}),
	},
});

const isVideo = computed(() => props.item.type === 'video');
</script>

<style lang="scss" scoped>
.gallery-item {
	position: relative;
	padding: 0 5px 10px;
}

a {
	display: block;

	&:hover {
		background-color: #000;

		img {
			cursor: pointer;
			opacity: 0.75;
		}

		.icon {
			opacity: 1;
		}
	}

	.icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #fff;
		font-size: 30px;
		opacity: 0;
		transition: opacity 0.3s ease-out;
		z-index: 1;
	}

	img {
		transition: opacity 0.3s ease-out;
		backface-visibility: hidden;
	}
}
</style>
